import * as Yup from 'yup'
import ValidationShema from 'constants/ValidationShema';
import Tr from 'translations/Translations';
import ImputLimits from 'constants/InputLimits';

const limits = ImputLimits.procedure.itemParameters;

export default (selectedItems) => Yup.lazy(values => {

	const reg = '^(?!(' + selectedItems.map(x => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')+ ')$).*$';
	const otherNameRegExp = new RegExp(reg)

	let shapeObj = {
		name: ValidationShema.stringExactlyMax(
			otherNameRegExp,
			Tr('v_position_exist'),
			limits.NAME
		)
	}

	return Yup.object().shape(shapeObj);
})